import axios from '@/utils/axios';
import { Cities } from '@/models/cities';
import { plainToClass } from 'class-transformer';
import { pickBy } from 'lodash';
export class CityService {
  static getCities(
    searchValue: string | undefined = undefined,
    surveyId?: string,
    page: number | null = 1
  ): Promise<Cities> {
    const params = pickBy({ city: searchValue, survey_id: surveyId, page });
    return axios
      .get(`cities/`, {
        params,
      })
      .then(({ data }) => {
        return plainToClass(Cities, data);
      });
  }
}
